module.exports = __webpack_public_path__ + "img/your-subscription-is-about-expire-3-en.7fddb2a.png";